export const periodsConstants = {
    GET_PERIODS_REQUEST: 'GET_PERIODS_REQUEST',
    GET_PERIODS_SUCCESS: 'GET_PERIODS_SUCCESS',
    GET_PERIODS_FAILURE: 'GET_PERIODS_FAILURE',

    SET_PERIODS_SUCCESS: 'SET_PERIODS_SUCCESS',
    SET_PERIODS_FAILURE: 'SET_PERIODS_FAILURE',

    GET_EXPANDED_PERIODS_REQUEST: 'GET_EXPANDED_PERIODS_REQUEST',
    GET_EXPANDED_PERIODS_SUCCESS: 'GET_EXPANDED_PERIODS_SUCCESS',
    GET_EXPANDED_PERIODS_FAILURE: 'GET_EXPANDED_PERIODS_FAILURE',

    SET_EXPANDED_PERIODS_REQUEST: 'SET_EXPANDED_PERIODS_REQUEST',
    SET_EXPANDED_PERIODS_SUCCESS: 'SET_EXPANDED_PERIODS_SUCCESS',
    SET_EXPANDED_PERIODS_FAILURE: 'SET_EXPANDED_PERIODS_FAILURE',
};
